import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router";
import { charityActions } from "store";
import { FindLoad, ProfileInfo } from "utils";
import {
  BackBtn,
  PageLoader,
  SearchInput,
  TabMain,
  TextToolTip,
} from "components";
import { AllStatusesEnum } from "fragments";
import { CHARITY_BY_ID, charityDetailTabs } from "./fragments";
import { charityDetailsTabs, tabsContent } from "./fragments/constants";

export const CharityDetail = () => {
  const { charityReports } = useSelector((state) => ({
    charityReports: state.charity.charityReports,
  }));
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { ifCharity } = ProfileInfo();
  const params = useParams();
  const loader = FindLoad(CHARITY_BY_ID);
  const location = useLocation();
  const info = location?.state;

  useEffect(() => {
    dispatch(charityActions.getCharityById(params?.id));
  }, [dispatch]);

  useEffect(() => {
    const sendParams = {
      ...info,
      charityId: params?.id,
    };

    if (info?.activeTab) {
      sendParams.type =
        info?.activeTab === charityDetailsTabs?.PendingBalance
          ? AllStatusesEnum.PENDING
          : info?.activeTab === charityDetailsTabs?.Payouts
          ? AllStatusesEnum.SUCCESS
          : info?.activeTab === charityDetailsTabs?.Failed
          ? AllStatusesEnum.FAILED
          : "";
    }

    if (sendParams.type) {
      dispatch(charityActions.getCharityReports(sendParams));
    }
  }, [dispatch, info]);

  if (loader) {
    return <PageLoader />;
  }

  return (
    <div className="fundraiser-details-page">
      {ifCharity ? (
        <div className="title-and-action-box">
          <p className="page-global-title">Charity Profile</p>
        </div>
      ) : (
        <BackBtn
          className="event-details-back-btn"
          handleClick={() => navigate("/charities")}
        />
      )}

      <TabMain
        classNameTabs="charity-details-tab"
        tabsLabels={charityDetailTabs}
        tabsContent={tabsContent}
        defaultTab="Details"
        besideTheTab={
          (info?.activeTab === "Pending Balance" ||
            info?.activeTab === "Payouts" ||
            info?.activeTab === "Failed") && (
            <div className="charity-search-input-total">
              <SearchInput
                className="charity-details-search-input"
                placeholder={"Search by name..."}
                searchKey={"name"}
              />
              {!!charityReports?.total && (
                <div className="charity-details-total">
                  <p className="charity-details-total-text">Total:</p>
                  <TextToolTip
                    text={charityReports?.total}
                    content={charityReports?.total}
                    textStyles={{ fontWeight: 500 }}
                    priceRow
                    arrow
                  />
                </div>
              )}
            </div>
          )
        }
      />
    </div>
  );
};
